const runInProduction = (fn: () => void) => {
  if (import.meta.env.MODE === 'production') {
    fn();
  }
};

const runInDevelopment = (fn: () => void) => {
  if (
    import.meta.env.MODE === 'development' ||
    import.meta.env.VITE_DEVELOPMENT_MODE === 'true'
  ) {
    fn();
  }
};

export { runInProduction, runInDevelopment };
